import { AuthData } from "../auth/AuthWrapper";

export const useGetUserInfo = () => {
  const { user, userProfile } = AuthData();
  const name = user?.name || userProfile?.displayName || "";
  const profilePhoto = userProfile?.photoURL || "";
  const userID = userProfile?.uid || "";
  return { name, profilePhoto, userID };
};
